import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api';
import { conversationKeys } from './conversations';

// Hook to run a task manually
export const useRunTask = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      scope,
      taskId,
    }: {
      scope: string;
      taskId: string;
    }) => {
      const { data } = await api.post(
        `/api/core/pleri/tasks/${scope}/${taskId}/run`,
        {},
      );
      // Refetch conversations to get the new execution
      await queryClient.refetchQueries({ queryKey: conversationKeys.all });
      return data;
    },
  });
};
